import React, { memo, useState } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import Icon from '@/components/Base/Icon';
import ProductCard from '@/components/Pages/Home/ProductCard';
import { COMPANY_MONITISATUON_TYPES } from '@/components/Pages/Home/ProductCard/ProductCard';

import { ButtonMoreProducts, Container } from './ProductCardWrapper.styles';

function ProductCardWrapper({ other = [], ...cardData }) {
  const { formatMessage } = useIntl();
  const [showOtherProducts, setShowOtherProducts] = useState(false);

  const otherProductsCount = other?.length;

  return (
    <Container>
      <ProductCard {...cardData} />

      {!!otherProductsCount && (
        <ButtonMoreProducts
          onClick={() => setShowOtherProducts(!showOtherProducts)}
          data-active={showOtherProducts}
        >
          {formatMessage(
            { id: 'productCard.moreProducts' },
            {
              count: otherProductsCount,
              nameG: cardData?.companyNameG || '',
            }
          )}

          <Icon width="8" name="arrow" />
        </ButtonMoreProducts>
      )}

      {!!otherProductsCount &&
        showOtherProducts &&
        other.map((item) => <ProductCard {...item} key={item.id} />)}
    </Container>
  );
}

const cardPropTypes = {
  productId: PropTypes.number.isRequired,
  slug: PropTypes.string.isRequired,
  companyMonetizationType: PropTypes.oneOf([
    COMPANY_MONITISATUON_TYPES.link,
    COMPANY_MONITISATUON_TYPES.form,
  ]),
  companySlug: PropTypes.string.isRequired,
  logoUrl: PropTypes.string,
  companyName: PropTypes.string.isRequired,
  vendorId: PropTypes.number.isRequired,
  requestConsiderationTerm: PropTypes.number,
  companyLicense: PropTypes.string,
  wayToGet: PropTypes.arrayOf(PropTypes.string),
  isPrepayment: PropTypes.bool,
  companyPromoLabel: PropTypes.string,
  effectiveInterestRate: PropTypes.shape({
    min: PropTypes.number,
    max: PropTypes.number,
  }),
  companyRating: PropTypes.string,
  companyRatingType: PropTypes.string,
  repeatConditions: PropTypes.shape({
    repeatedLoanValue: PropTypes.number,
    repeatedTermRange: PropTypes.objectOf(
      PropTypes.shape({ type: PropTypes.string })
    ),
    repeatedRate: PropTypes.number,
    repeatedForClientsOnly: PropTypes.bool,
  }),
  loanLimitNumber: PropTypes.shape({
    min: PropTypes.number,
    max: PropTypes.number,
  }),
  loanRateYear: PropTypes.number,
  termMonths: PropTypes.shape({
    min: PropTypes.number,
    max: PropTypes.number,
  }),
  productUserWarningUrl: PropTypes.string,
  productEssentialCharacteristicsUrl: PropTypes.string,
  advantages: PropTypes.arrayOf(
    PropTypes.shape({ title: PropTypes.string, description: PropTypes.string })
      .isRequired
  ).isRequired,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      validFrom: PropTypes.string,
      validTo: PropTypes.string,
    }).isRequired
  ).isRequired,
  productName: PropTypes.string.isRequired,
  companyNameG: PropTypes.string.isRequired,
  trackingUrl: PropTypes.string,
};

ProductCardWrapper.propTypes = {
  other: PropTypes.arrayOf(PropTypes.shape(cardPropTypes)),
};

export default memo(ProductCardWrapper);
